import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import { TextInput } from 'react-admin';
import { useWatch, useFormContext } from 'react-hook-form';

import { useCopyStringToClipboard } from '@src/hooks/use-copy-string-to-clipboard';

const TextCopyInput = ({ copyButtonTitle = 'Copy', ...props }) => {
    const { control } = useFormContext();
    const fieldValue = useWatch({ name: props.source, control });
    const copyCallback = useCopyStringToClipboard(fieldValue);

    let suffix = null;
    if (fieldValue) {
        suffix = (
            <InputAdornment position="end">
                <Button
                    size="small"
                    color="primary"
                    onClick={copyCallback}
                >
                    { copyButtonTitle }
                </Button>
            </InputAdornment>
        );
    }

    return (
        <TextInput
            {...props}
            InputProps={{ endAdornment: suffix }}
        />
    );
};

TextCopyInput.propTypes = {
    copyButtonTitle: PropTypes.string,
    source: PropTypes.string.isRequired,
};

export default React.memo(TextCopyInput);
